export default "__VITE_ASSET__Bd7I6adn__"